var _circle, _circle2, _circle3, _circle4, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEquipments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 18.3198,
    r: 2,
    stroke: "#393939"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.8335,
    cy: 7.48645,
    r: 2,
    stroke: "#393939"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.1665,
    cy: 14.1532,
    r: 2,
    stroke: "#393939"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 3.31982,
    r: 2,
    stroke: "#393939"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6794 12.4865L16.9382 5.14526M12.6631 12.9504L7.22003 8.59597M5.32039 9.15319L3.0127 16.6532",
    stroke: "#393939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipments);
export default __webpack_public_path__ + "static/media/equipments.4e28b53f3e69174b93091ee4acdaac3e.svg";
export { ForwardRef as ReactComponent };